import { Datasets, ID_COLUMN } from "../constants";
import * as d3Fetch from "d3-fetch";
import * as d3Dsv from "d3-dsv";
import { TRow } from "../types";

const readFileAsync = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsText(file);
  });

class DatasetManager {
  static findSource(datasetName: string) {
    const dataset = Datasets.find((d) => d.name === datasetName);
    return dataset?.source;
  }

  static async readSource(source: string) {
    const rows = await d3Fetch.csv(source);
    return rows;
  }

  static async readFromFile(file: File) {
    const content = await readFileAsync(file);
    const rows = await d3Dsv.csvParse(content);
    return rows;
  }

  static validateDataset(firstRow: TRow) {
    let errors: string[] = [];

    if (!firstRow) {
      errors.push(`Could not parse dataset`);
      return errors;
    }

    if (!firstRow.hasOwnProperty(ID_COLUMN)) {
      errors.push(`Missing column ${ID_COLUMN}`);
    }

    return errors;
  }
}

export default DatasetManager;
